module.exports = __webpack_public_path__ + "img/qr.2828d381.svg";